import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import DefaultLayout from '@/layouts/Default.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: DefaultLayout,
    meta: { checkAuth: true },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/edit',
        name: 'edit',
        component: () => import('@/views/Editor.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/callback',
    name: 'Callback',
    component: () => import('@/views/Callback.vue'),
  },
]

const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.checkAuth)) {
    const authed = store.getters['auth/isLoggedIn'];
    if (!authed) {
      return next('/login');
    }
  }

  return next();
});

export default router
